import { useMediaQuery } from "@mui/material";
import { mobileWidth } from "@qubit/autoparts";
import { useMemo, useState } from "react";

export const usePagination = <T>({
  rows,
  rowsPerPage,
  disablePaginationOnMobile = false
}: {
  rows: T[] | undefined;
  rowsPerPage: number;
  disablePaginationOnMobile?: boolean;
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const isMobile = useMediaQuery(mobileWidth);

  const pageLimit = useMemo(() => {
    if (disablePaginationOnMobile && isMobile) return rows?.length || 0;
    return rowsPerPage;
  }, [disablePaginationOnMobile, isMobile, rows?.length, rowsPerPage]);

  const totalPages = useMemo(() => {
    if (!rows || rows.length === 0) return 0;
    if (disablePaginationOnMobile && isMobile) return 1;
    return Math.ceil(rows.length / pageLimit);
  }, [disablePaginationOnMobile, isMobile, rows, pageLimit]);

  const currentPageRows = useMemo(() => {
    if (!rows || rows.length === 0) return [];
    if (disablePaginationOnMobile && isMobile) return rows;

    const startIndex = (currentPage - 1) * pageLimit;
    const endIndex = startIndex + pageLimit;
    return rows.slice(startIndex, endIndex);
  }, [disablePaginationOnMobile, isMobile, rows, pageLimit, currentPage]);

  return {
    currentPage,
    setCurrentPage,
    pageLimit,
    totalPages,
    currentPageRows
  };
};
